import { useCalendar } from "./useCalendar"

export const useTags = (subdomain: string, calendarId: string) => {
  const results = useCalendar(subdomain, calendarId)
  return { ...results, tags: results.calendar?.tags }
}
